import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface X2PropRecOnpModel extends BaseModel {
  variables?: { [key: string]: string } | X2PropRecOnpVariables;
}

export interface X2PropRecOnpVariables {
  X2Onp1Image: string;
  X2Onp2Image: string;
  X2Onp1ImageHref: string;
  X2Onp2ImageHref: string;
  X2Onp1ImageAlt: string;
  X2Onp2ImageAlt: string;
  X2Onp1Name: string;
  X2Onp2Name: string;
  X2Onp1CtaLink: string;
  X2Onp2CtaLink: string;
  X2Onp1CtaText: string;
  X2Onp2CtaText: string;
  X2Onp1OldPrice: string;
  X2Onp1NewPrice: string;
  X2Onp2OldPrice: string;
  X2Onp2NewPrice: string;
  X2Onp1ImageHrefSegmentRegex: string;
  X2Onp2ImageHrefSegmentRegex: string;
  X2Onp1CtaLinkSegmentRegex: string;
  X2Onp2CtaLinkSegmentRegex: string;

}

export class X2PropRecOnpInitVariables implements X2PropRecOnpVariables {
  X2Onp1Image = '';
  X2Onp2Image = '';
  X2Onp1ImageHref = '';
  X2Onp2ImageHref = '';
  X2Onp1ImageAlt = '';
  X2Onp2ImageAlt = '';
  X2Onp1Name = '';
  X2Onp2Name = '';
  X2Onp1CtaLink = '';
  X2Onp2CtaLink = '';
  X2Onp1CtaText = '';
  X2Onp2CtaText = '';
  X2Onp1OldPrice = '';
  X2Onp1NewPrice = '';
  X2Onp2OldPrice = '';
  X2Onp2NewPrice = '';
  X2Onp1ImageHrefSegmentRegex = '';
  X2Onp2ImageHrefSegmentRegex = '';
  X2Onp1CtaLinkSegmentRegex = '';
  X2Onp2CtaLinkSegmentRegex = '';
}

export class X2PropRecOnpInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new X2PropRecOnpInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
